export const TRANS_KEY_FAVORITES = 'QUERY_BUILDER.FAVORITES';
export const TRANS_KEY_CONFIRM_MODAL = `${TRANS_KEY_FAVORITES}.DELETE.CONFIRM_MODAL`;
